import { useState, useEffect, useRef } from "react";
import QueueTimeStore from "components/stores/queue-times-store";
import { useIsParkOpenNow } from "components/hooks/opening-hours-hooks";

const useFetchQueueTime = (rideId = false, updateInterval = 60000) => {
  const [queueTime, setQueueTime] = useState();
  const intervalReference = useRef(null);

  function fetchQueueTime() {
    QueueTimeStore.getQueueTimes()
      .then((response) => {
        return setQueueTime(rideId ? response.find((ride) => rideId === ride.attractionId) : response);
      })
      .catch((err) => {
        console.log("Fetch queueTime failed: ", err);
        return null;
      });
  }

  useEffect(() => {
    fetchQueueTime();

    if (intervalReference.current) {
      clearInterval(intervalReference.current);
    }

    intervalReference.current = setInterval(fetchQueueTime, updateInterval);
  }, [rideId, updateInterval]);

  useEffect(() => {
    return () => {
      if (intervalReference.current) {
        clearInterval(intervalReference.current);
      }
    };
  }, []);

  return queueTime;
};

const FetchQueueTime = ({ rideId, updateInterval, onUpdate }) => {
  const data = useFetchQueueTime({ rideId, updateInterval });
  useEffect(() => {
    onUpdate(data);
  }, [data, onUpdate]);

  return null;
};

/**
 * Check if conditions are met to display ride queue times
 * @param {string} enableRideQueueTimesUrlKey Optional string to check if it exists in current URL
 * @returns {boolean}
 */
const useDisplayAttractionQueueTime = (enableRideQueueTimesUrlKey = null) => {
  const isParkOpenNow = useIsParkOpenNow();

  const getDisplayAttractionQueueTime = () => {
    const isBrowser = typeof window !== "undefined";
    let currentUrlContainKey = false;
    if (enableRideQueueTimesUrlKey && isBrowser) {
      currentUrlContainKey = window.location.href.toLowerCase().indexOf(enableRideQueueTimesUrlKey.toLowerCase()) > 0;
    }

    const shouldDisplayAttractionQueueTime = currentUrlContainKey
      ? currentUrlContainKey && isParkOpenNow
      : isParkOpenNow;

    return shouldDisplayAttractionQueueTime;
  };

  const [displayAttractionQueueTime, setDisplayAttractionQueueTime] = useState(getDisplayAttractionQueueTime());

  useEffect(() => {
    setDisplayAttractionQueueTime(getDisplayAttractionQueueTime());
  }, [isParkOpenNow, enableRideQueueTimesUrlKey]);

  return displayAttractionQueueTime;
};

export { useFetchQueueTime, FetchQueueTime, useDisplayAttractionQueueTime };
